<template>
  <div>
    <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false"
           width="600">
      <Card :bordered="false" :style="{marginBottom:'10px'}">
        <div class="hs-screen-row">
          <Input v-model="params.nickName" placeholder="昵称" clearable style="width: 200px"/>
        </div>
        <div class="hs-screen-row">
          <Button type="primary" @click="findList">查询</Button>
        </div>
        <div class="hs-screen-row">
          <Button @click="resetScreen">重置</Button>
        </div>
      </Card>
      <Card :bordered="false" :style="{marginBottom:'10px'}">
        <!--表格数据-->
        <Table :columns="columns" :data="data" size="small" :stripe="true" ref="selection2"  @on-selection-change="handleSelectRow(2)" :loading="isTableLoading">
          <template slot-scope="{ row, index}" slot="isVip">
            <Tag color="green" v-if="row.isVip === 0" size="default">否</Tag>
            <Tag color="volcano" v-if="row.isVip === 1" size="default">是</Tag>
          </template>

        </Table>
        <!--分页-->
        <div class="hs-page">
          <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                @on-page-size-change="changePageSize"/>
        </div>
      </Card>

      <!-- 重写对话框底部按钮 -->
      <div slot="footer">
        <Button @click="save()">保存</Button>
        <Button @click="hide('formValidate')">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowModal: false,
      loadingBtn: false,
      title: '用户列表',
      total: 0,
      params: {
        page: 1,
        rows: 10,
        nickName: '',
        userId: ''
      },
      isTableLoading: false,
      // 表格列
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '昵称',
          minWidth: 180,
          key: 'nickName'
        },
        {
          title: '星标用户',
          minWidth: 180,
          slot: 'isVip'
        },
      ],
      // 表格数据
      data: [],
      userIds: []
    }
  },
  methods: {
    // 显示模态框
    show() {
      this.isShowModal = true;
      this.userIds = []
      this.findList();
    },
    // 查询用户列表
    findList() {
      this.$Spin.show();
      this.axios.post('/activityUser/findNotUserList', this.params).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询用户列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 重置筛选条件
    resetScreen() {
      this.params.nickName = '';
      this.params.page = 1
      this.params.rows = 10
      this.findList();
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    // 关闭模态框
    hide(name) {
      this.isShowModal = false;
      // this.$refs[name].resetFields();
    },
    save() {
      if (this.userIds.length === 0) {
        this.$Notice.error({
          title: '添加失败',
          desc: '请先选择参与活动的用户！'
        });
        return ;
      }
      this.axios.post('/activityUser/saveActivityUser', {userArr: this.userIds}).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        this.isTableLoading = false;
        if (res.status == 201) {
          this.$Notice.error({
            title: '添加失败',
            desc: res.msg
          });
        }
        if (res.status == 200) {
          this.$emit('changeDate');
          this.userIds = []
          this.$Message.success('添加成功.');
          this.hide('formValidate');
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询用户列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
    handleSelectRow(index) {
      let ids=[];
      this.$refs['selection2'].getSelection().map(item=>{
        ids.push(item.userId)
      })
      this.userIds=ids
      console.log('ids', ids)
    },
    onSelect() {
      console.log()
    }
  },
}
</script>

<style scoped>
.jw-images-row {
  display: flex;
  align-items: center;
}

.jw-image {
  width: 150px;
  height: 150px;
  margin-right: 10px;
}
</style>
